export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_CHOOSE_QUOTE_STATE = true;
export const DEFAULT_PIPELINE_FILTER = { id: 0, name: 'All' };
